
export const environment = {
  production: true,
  apiURL: 'https://infokaw.com.br/api',
  siteKey: '6Lc48LYZAAAAAJk7qXiBpsfwgvVZUCghv7Ty9XoG',
  mqtt: {
		server: 'infokaw.com.br',
		protocol: "wss",
		port: 8883,
    useSSL: true,
    path: "/mqtt",
    clientId: "SUPERVISORIO-HTTPS",
    username: 'api',
    password: '@9a03b933a5'
	}
};